import firebase from "../firebase";
import {
  GET_RESTAURANTS_ERROR,
  GET_RESTAURANTS_LOADING,
  GET_RESTAURANTS_SUCCESS,
} from "./types";

export const fetchRestaurants = () => async (dispatch) => {
  dispatch({
    type: GET_RESTAURANTS_LOADING,
  });

  try {
    // const restaurants = [];
    const user = firebase.auth().currentUser;
    try {
      const snapshots = await firebase
        .firestore()
        .collection("restaurant")
        .where(`staff.${user.uid}`, "==", true)
        .get();
      const restaurants = {};
      snapshots.forEach((doc) => {
        restaurants[doc.id] = doc.data();
      });

      dispatch({
        type: GET_RESTAURANTS_SUCCESS,
        payload: restaurants,
      });
    } catch (error) {
      console.log({ error });
    }
  } catch (error) {
    dispatch({
      type: GET_RESTAURANTS_ERROR,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/restaurants.actions.js